import React from 'react';
import { Box } from '@oneboard/ui-components';
import { VideoSingleList } from 'containers';

export default function MainPageHeader() {

  return <Box width="100%" height="100%">
    <VideoSingleList />
  </Box>;
}